import { Grid, Typography } from "@material-ui/core";
import React, { useContext, useState } from "react";
import backgroundProvider from "../../../assets/img/backgroundProvider.png";
import DatePicker from "../../../components/common/DatePicker";
import ShowImage from "../../../components/common/ShowImage";
import UserContext from "../../../context/user-context";
import useInputUserChange from "../../../hooks/useInputUserChange";
import useShowImage from "../../../hooks/useShowImage";
import useStateDate from "../../../hooks/useStateDate";
import { useTranslation } from "../../../hooks/useTranslation";
import useUploadImage from "../../../hooks/useUploadImage";
import { fileNames } from "../../../utils/imageUtil";
import { CompanionTabIndex, EntrantTabIndex } from "../../../utils/tabIndex";

const CriminalRecords = () => {
  const getImage = useShowImage();
  const { state } = useContext(UserContext);
  const { t, BundleKey } = useTranslation();
  const { uploadNewPhoto } = useUploadImage();
  const [criminalRecordPhoto1, setCriminalRecordPhoto1] = useState<any>(
    getImage(state.criminalRecordPhoto1)
  );
  const [criminalRecordPhoto2, setCriminalRecordPhoto2] = useState<any>(
    getImage(state.criminalRecordPhoto2)
  );
  const { handleDatePickerChange } = useInputUserChange();
  const { date, setDate } = useStateDate(state.criminalRecordIssueDate);

  const uploadNewCriminalRecordPhotoOne = (newPhoto: any) => {
    setCriminalRecordPhoto1(newPhoto);
    uploadNewPhoto(
      newPhoto,
      "criminalRecordPhoto1",
      fileNames.CRIMINAL_RECORD_PHOTO_1_FILENAME,
      isFull()
    );
  };

  const uploadNewCriminalRecordPhotoTwo = (newPhoto: any) => {
    setCriminalRecordPhoto2(newPhoto);

    uploadNewPhoto(
      newPhoto,
      "criminalRecordPhoto2",
      fileNames.CRIMINAL_RECORD_PHOTO_2_FILENAME,
      isFull()
    );
  };

  const isFull = () => {
    return state.registrationType === "full";
  };

  return (
    <Grid container direction="column" spacing={3}>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          {t(BundleKey.DETAIL_PROVIDER_ANTECEDENT_TITLE)}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <DatePicker
          id="criminalRecordIssueDate"
          name="criminalRecordIssueDate"
          value={date}
          label={t(BundleKey.DETAIL_PROVIDER_ANTECEDENT_DATE_PLACEHOLDER)}
          size="medium"
          tabIndex={
            state.config?.companion
              ? CompanionTabIndex.dateOfIssue
              : EntrantTabIndex.dateOfIssue
          }
          onchange={(date) => {
            setDate(date);
            handleDatePickerChange(
              "criminalRecordIssueDate",
              date,
              "isInvalidCriminalRecordIssueDate"
            );
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Grid container direction="row" spacing={3}>
          <Grid item xs={12} sm={6}>
            <ShowImage
              title={t(BundleKey.DETAIL_PROVIDER_ACCIDENTS_FIRSTPHOTO)}
              defaultImage={backgroundProvider}
              image={criminalRecordPhoto1}
              uploadNewPhoto={uploadNewCriminalRecordPhotoOne}
              alt="image photo criminal record"
              circle={false}
              small
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <ShowImage
              title={t(BundleKey.DETAIL_PROVIDER_ACCIDENTS_SECONDPHOTO)}
              defaultImage={backgroundProvider}
              image={criminalRecordPhoto2}
              uploadNewPhoto={uploadNewCriminalRecordPhotoTwo}
              alt="image photo criminal record"
              circle={false}
              small
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CriminalRecords;
